import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Tree from '@/components/tree/Tree.vue'
import Cam from '@/components/cam/Cam.vue'

export default {
  name: 'MapList',
  props: {
    maps: {
      type: Array,
      default: []
    },
    routeName: {
      type: String,
      default: 'map' // map || views
    },
    search: {
      type: String,
      default: ''
    },
    showObjects: {
      type: Boolean,
      default: false
    },
    openDefault: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mapData() {
      return this.getMapGroup(this.maps)
    }
  },
  components: {
    VuePerfectScrollbar,
    Tree,
    Cam
  },
  methods: {
    getMapGroup(mapList) {
      const result = mapList.map(group => {
        if (group) {
          const map = group.map.reduce((acc, item) => {
            const itemCorrect = {
              value: item.id,
              name: item.name,
              parent: item.parent
            }
            let cams = []
            if (this.showObjects && item.objects && item.objects.length) {
              cams = this.$store.getters.getCamsMap(item.objects)
              .map(cam => ({
                /**
                 * именно item.id - то есть id карты,
                 * так как по итогу нажатие на элемент должно
                 * установить нужную карту
                 */
                value: item.id,
                name: cam.name,
                parent: item.id,
                ...cam
              }))
            }
            /**
             * Порядок добавления acc, cams, itemCorrect ОБЯЗАТЕЛЕН!!!
             */
            const result = [ ...acc, itemCorrect, ...cams]
            return result
          }, [])

          return {
            value: group.id,
            name: group.name,
            children: map,
            isHighRoot: true
          }
        }
      })
      return result
    },

    checkSameRoute(newRouteObj) {
      if (this.$route.name !== newRouteObj.name) {
          return false
      }
      const paramsKeys = Object.keys(this.$route.params)
      for (let i = 0; i < paramsKeys.length; i++) {
          const key = paramsKeys[i]
          if (this.$route.params[key] !== newRouteObj.params[key]) {
              return false
          }
      }
      return true
    },

    setMap(map) {
      if (this.routeName === 'map' && !map.value) {
          return
      }
      const params = { mapGroupId: map.root, mapId: map.value }
      if (this.routeName === 'views') {
        params.viewId = 'main'
      }
      const newRouteObj = { name: this.routeName, params: params }
      if (!this.checkSameRoute(newRouteObj)) {
        this.$router.push(newRouteObj)
      }
      this.$emit('map-setted')
    },

    updateScroll() {
      this.$nextTick(() => {
          this.$refs.mapListScroll.update()
      })
    },
  }
}


// WEBPACK FOOTER //
// ./src/components/mapList/mapList.js